import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../service/global.service';
import { PharmacieService } from '../service/pharmacie.service';
import { PharmacieDto } from '../DTO/pharmacie.dto';
import { BnNgIdleService } from 'bn-ng-idle';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  title = 'monpharmacien-web';
  loading_gif: any = 'assets/images/loading.gif';

  constructor(
    public globalService: GlobalService,
    protected pharmacieService: PharmacieService,
    private bnIdle: BnNgIdleService
  ) {}

  ngOnInit() {
    this.pharmacieService.getMe().subscribe(data => {
      this.globalService.pharmacie = PharmacieDto.fromJson(data);
      this.globalService.isDataLoaded = true;
    });

    this.bnIdle.startWatching(environment.IDLE_TIMEOUT).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        this.pharmacieService.logout().subscribe();
      }
    });
  }

}
